import React, { createContext, useEffect, useState } from 'react';
import { projects2 } from '../mocks';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import Fetch from '../../functions/Fetch';
import config from '../../../../../config/config';

const EntityProjectsContext = createContext();

export const EntityProjectsProvider = ({ children }) => {
  const dispatch = useDispatch();

  const { friendly_url } = useParams();

  const sessionSelector = useSelector((state) => { return state.core.session });

  useEffect(() => {
    // Limpa dados de projeto de sessões anteriores ao entrar numa entidade nova via URL
    dispatch({ type: 'UPDATE_SESSION', key: 'pdc_project_friendly_url', value: null });
    dispatch({ type: 'UPDATE_SESSION', key: 'pdc_project_id', value: null });

    const loadData = async () => {
      let customData;

      const bodyCustomization = {
        friendly_url,
        entity: true
      }

      if (friendly_url) {
        customData = await Fetch.post(`${config.endpoints.backend}portal/getcustomizations`, bodyCustomization);

        if (customData) {
          customData.logo = config.endpoints.backend + customData.logo;
          customData.background_image = config.endpoints.backend + customData.background_image;
          setInfos({
            displayMode: customData.theme,
            primary_color: customData.primary_color,
            content_color: customData.content_color,
            bannerURL: customData.background_image,
            header: {
              title: "Plataforma de Transparência",
              subtitle: customData.entity_name,
              logoURL: customData.logo,
            },
            banner: {
              title: customData.project_name,
              subtitle: customData.description,
              description: customData.object
            }
          })

          dispatch({ type: 'UPDATE_SESSION', key: 'employee_payment_portal_view', value: customData.employee_payment_portal_view });
        }
      }

      const projects = await Fetch.post(`${config.endpoints.backend}portal/getallprojects`, { filter: { friendly_url } });
      setProjectsPage1(projects)
    };

    loadData();
  }, []);

  const [pageToRender, setPageToRender] = useState(1);
  const [projectsPage1, setProjectsPage1] = useState([]);
  const [projectsPage2, setProjectsPage2] = useState([]);
  const [infos, setInfos] = useState({
    displayMode: '1',
    primary_color: '#000',
    content_color: '#fff',
    header: {
      title: '',
      subtitle: '',
      logoURL: '',
    },
    banner: {
      title: '',
      subtitle: '',
      description: ''
    }
  });

  useEffect(() => {
    setProjectsPage2(projects2);
  }, []);


  return (
    <EntityProjectsContext.Provider value={{ infos, setInfos, pageToRender, setPageToRender, projectsPage1, setProjectsPage1, projectsPage2, setProjectsPage2 }}>
      {children}
    </EntityProjectsContext.Provider>
  );
};

export default EntityProjectsContext;
